import React from 'react';
import Header from '../components/Header';
import MobileNav from '../components/MobileNav';
import SearchPopup from '../components/SearchPopup';
import DonateFooter from '../components/DonateFooter';

const DonateNow = () => {
  return (
    <>
      <MobileNav />
      <SearchPopup />

      {/* Custom cursors */}
      <div className="custom-cursor__cursor"></div>
      <div className="custom-cursor__cursor-two"></div>

      <div className="page-wrapper">
        <Header />

        {/* Sticky header placeholder */}
        <div className="stricky-header stricked-menu main-menu">
          <div className="sticky-header__content"></div>
        </div>

        {/* Page Header Start */}
        <section className="page-header">
          <div className="page-header__bg" style={{ backgroundImage: 'url(assets/images/5.jpg)' }}></div>
          <div className="page-header__shape-bg" style={{ backgroundImage: 'url(assets/images/shapes/page-header-shape-bg.png)' }}></div>
          <div className="page-header__shape-1 float-bob-x">
            <img src="assets/images/shapes/page-header-shape-1.png" alt="" />
          </div>
          <div className="page-header__shape-2 float-bob-y">
            <img src="assets/images/shapes/page-header-shape-2.png" alt="" />
          </div>
          <div className="container">
            <div className="page-header__inner">
              <h2>Donate Now</h2>
              <div className="thm-breadcrumb__box">
                <ul className="thm-breadcrumb list-unstyled">
                  <li><a href="/">Home</a></li>
                  <li><span className="fas fa-angle-right"></span></li>
                  <li>Donate Now</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* Page Header End */}

        {/* Donate Now Start */}
        <section className="donate-now">
          <div className="container">
            <div className="donate-now__inner">
              <div className="donate-now__payment-method-box">
                <h3 className="donate-now__payment-method-title">Select Payment Method</h3>
                <div className="donate-now__quote-radio">
                  <label className="custom-radio">
                    <input type="radio" name="paymentMethod" value="visa" defaultChecked />
                    <span className="radio-dot"></span>
                    <span className="radio-text">Visa</span>
                  </label>
                  <label className="custom-radio">
                    <input type="radio" name="paymentMethod" value="paypal" />
                    <span className="radio-dot"></span>
                    <span className="radio-text">Paypal</span>
                  </label>
                </div>
              </div>
              <div className="donate-now__personal-info">
                <h3 className="donate-now__personal-info-title">Personal Information</h3>
                <form className="contact-form-validated donate-now__form" action="assets/inc/sendemail.php" method="post" noValidate>
                  <div className="row">
                    <div className="col-xl-6 col-lg-6">
                      <div className="donate-now__input-box">
                        <p className="donate-now__input-box-title">Your First Name*</p>
                        <input type="text" name="FirstName" placeholder="First Name..." required />
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                      <div className="donate-now__input-box">
                        <p className="donate-now__input-box-title">Your Last Name*</p>
                        <input type="text" name="LastName" placeholder="Last Name..." required />
                      </div>
                    </div>
                    <div className="col-xl-12 col-lg-12">
                      <div className="donate-now__input-box">
                        <p className="donate-now__input-box-title">Your E-mail Address*</p>
                        <input type="email" name="Email" placeholder="E-mail Address..." required />
                      </div>
                    </div>

                    <div className="col-xl-12 col-lg-12">
                      <div className="donate-now__donate-box-outer">
                        <div className="donate-now__donate-box">
                          <div className="donate-now__amount-box">
                            <p className="donate-now__input-box-title">Enter Donation Amount*</p>
                            <input type="text" className="addAmount-value" placeholder="₦ Custom Amount" />
                          </div>
                          <h4 className="donate-now__donate-box-divider">Or</h4>
                          <div className="donate-amount">
                            <p className="donate-now__input-box-title">Select Amount*</p>
                            <button type="button" className="active amount-btn">₦5,000</button>
                            <button type="button" className="amount-btn">₦10,000</button>
                            <button type="button" className="amount-btn">₦20,000</button>
                          </div>
                        </div>
                        <h3 className="donate-now__donate-amout"><span>Total Amount: </span>₦0</h3>
                      </div>
                    </div>

                    <div className="col-xl-12">
                      <div className="donate-now__btn-box">
                        <button type="submit" className="thm-btn donate-now__btn">
                          <span className="thm-btn-text">Donate Now</span>
                          <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        {/* Donate Now End */}

        <DonateFooter />
      </div>
    </>
  );
};

export default DonateNow;
